import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';

export default function Home() {
  const [originalTotal, setOriginalTotal] = useState(25);
  const [savings, setSavings] = useState(0);
  const [isCalculating, setIsCalculating] = useState(false);

  // Animated savings calculation
  useEffect(() => {
    const calculateSavings = () => {
      setIsCalculating(true);
      const finalTotal = originalTotal * 0.6; // Exact 60% of DoorDash total
      const calculatedSavings = originalTotal - finalTotal;
      
      // Animate the savings number
      let currentSavings = 0;
      const increment = calculatedSavings / 20;
      const interval = setInterval(() => {
        currentSavings += increment;
        if (currentSavings >= calculatedSavings) {
          setSavings(calculatedSavings);
          setIsCalculating(false);
          clearInterval(interval);
        } else {
          setSavings(currentSavings);
        }
      }, 50);
    };

    calculateSavings();
  }, [originalTotal]);

  return (
    <div style={{textAlign: 'center', marginTop: 40}}>
      <h2>Welcome to Clickybois</h2>
      <p>Order food, manage deliveries, and more.</p>
      
      {/* Hours Section */}
      <div style={{
        background: 'rgba(255, 255, 255, 0.1)',
        borderRadius: '12px',
        padding: '24px',
        margin: '32px auto',
        maxWidth: '400px',
        border: '1px solid rgba(255, 255, 255, 0.2)'
      }}>
        <h3 style={{color: '#fff', marginBottom: '16px', fontSize: '1.3em'}}>
          🕒 Hours of Operation
        </h3>
        
        <div style={{color: '#ccc', lineHeight: '1.6', marginBottom: '16px'}}>
          <div style={{fontWeight: '600', color: '#fff', marginBottom: '8px'}}>
            Monday - Saturday
          </div>
          <div style={{fontSize: '1.1em', color: '#ffe082'}}>
            3:00 PM - 9:00 PM
          </div>
          
          <div style={{fontWeight: '600', color: '#fff', marginTop: '16px', marginBottom: '8px'}}>
            Sunday
          </div>
          <div style={{fontSize: '1.1em', color: '#ff6b6b'}}>
            Closed
          </div>
          
          <div style={{
            fontSize: '0.9em',
            color: '#aaa',
            marginTop: '16px',
            padding: '12px',
            background: 'rgba(255, 224, 130, 0.1)',
            borderRadius: '8px',
            border: '1px solid rgba(255, 224, 130, 0.3)'
          }}>
            ⏰ All times are in Central Standard Time (CST)
          </div>
        </div>
        
        <div style={{
          fontSize: '0.85em',
          color: '#90caf9',
          fontStyle: 'italic',
          marginTop: '12px'
        }}>
          🚀 Expanded hours coming soon!
        </div>
      </div>
      
      {/* Savings Calculator */}
      <div style={{
        background: 'rgba(255, 255, 255, 0.1)',
        borderRadius: '12px',
        padding: '24px',
        margin: '32px auto',
        maxWidth: '450px',
        border: '1px solid rgba(255, 255, 255, 0.2)'
      }}>
        <h3 style={{color: '#fff', marginBottom: '20px', fontSize: '1.3em'}}>
          💰 Savings Calculator
        </h3>
        <div style={{
          color: '#4caf50',
          fontSize: '1.1em',
          fontWeight: '600',
          marginBottom: '16px',
          background: 'rgba(76, 175, 80, 0.2)',
          padding: '8px 12px',
          borderRadius: '6px',
          border: '1px solid rgba(76, 175, 80, 0.4)'
        }}>
          🎉 40% OFF DoorDash Orders!
        </div>
        
        <div style={{marginBottom: '20px'}}>
          <label style={{
            display: 'block',
            color: '#fff',
            marginBottom: '8px',
            fontSize: '0.9em'
          }}>
            Original DoorDash Total:
          </label>
          <input
            type="range"
            min="15"
            max="50"
            value={originalTotal}
            onChange={(e) => setOriginalTotal(parseFloat(e.target.value))}
            style={{
              width: '100%',
              height: '8px',
              borderRadius: '4px',
              background: '#333',
              outline: 'none',
              cursor: 'pointer'
            }}
          />
          <div style={{
            color: '#ffe082',
            fontSize: '1.2em',
            fontWeight: '600',
            marginTop: '8px'
          }}>
            ${originalTotal.toFixed(2)}
          </div>
        </div>
        
        <div style={{
          background: 'rgba(76, 175, 80, 0.2)',
          borderRadius: '8px',
          padding: '16px',
          marginBottom: '16px',
          border: '1px solid rgba(76, 175, 80, 0.4)'
        }}>
          <div style={{color: '#fff', fontSize: '0.9em', marginBottom: '8px'}}>
            You Pay:
          </div>
          <div style={{
            color: '#4caf50',
            fontSize: '1.5em',
            fontWeight: '700'
          }}>
            ${(originalTotal * 0.6).toFixed(2)}
          </div>
        </div>
        
        <div style={{
          background: 'rgba(255, 193, 7, 0.2)',
          borderRadius: '8px',
          padding: '16px',
          border: '1px solid rgba(255, 193, 7, 0.4)'
        }}>
          <div style={{color: '#fff', fontSize: '0.9em', marginBottom: '8px'}}>
            You Save:
          </div>
          <div style={{
            color: '#ffc107',
            fontSize: '1.5em',
            fontWeight: '700',
            animation: isCalculating ? 'pulse 0.5s ease-in-out' : 'none'
          }}>
            ${savings.toFixed(2)}
          </div>
        </div>
        
        <div style={{
          fontSize: '0.8em',
          color: '#aaa',
          marginTop: '16px',
          fontStyle: 'italic'
        }}>
          * You pay exactly 60% of the DoorDash total (40% savings).
        </div>
      </div>
      
      <div style={{
        background: 'rgba(255, 255, 255, 0.05)',
        borderRadius: '16px',
        padding: '24px',
        marginTop: '24px',
        border: '1px solid rgba(255, 255, 255, 0.1)'
      }}>
        <h3 style={{color: '#fff', marginBottom: '16px', fontSize: '1.3em'}}>
          🕒 Hours of Operation
        </h3>
        
        <div style={{color: '#ccc', lineHeight: '1.6', marginBottom: '16px'}}>
          <div style={{fontWeight: '600', color: '#fff', marginBottom: '8px'}}>
            Monday - Saturday
          </div>
          <div style={{fontSize: '1.1em', color: '#ffe082'}}>
            3:00 PM - 9:00 PM
          </div>
          
          <div style={{fontWeight: '600', color: '#fff', marginTop: '16px', marginBottom: '8px'}}>
            Sunday
          </div>
          <div style={{fontSize: '1.1em', color: '#ff6b6b'}}>
            Closed
          </div>
          
          <div style={{
            fontSize: '0.9em',
            color: '#aaa',
            marginTop: '16px',
            padding: '12px',
            background: 'rgba(255, 224, 130, 0.1)',
            borderRadius: '8px',
            border: '1px solid rgba(255, 224, 130, 0.3)'
          }}>
            ⏰ All times are in Central Standard Time (CST)
          </div>
        </div>
        
        <div style={{
          fontSize: '0.85em',
          color: '#90caf9',
          fontStyle: 'italic',
          marginTop: '12px'
        }}>
          🚀 Expanded hours coming soon!
        </div>
      </div>
      
      {/* Get Started Button */}
      <div style={{
        marginTop: '40px',
        textAlign: 'center'
      }}>
        <Link to="/signin" style={{textDecoration: 'none'}}>
          <button style={{
            background: 'linear-gradient(135deg, #4caf50, #45a049)',
            color: 'white',
            border: 'none',
            borderRadius: '12px',
            padding: '16px 32px',
            fontSize: '1.2em',
            fontWeight: '600',
            cursor: 'pointer',
            boxShadow: '0 4px 15px rgba(76, 175, 80, 0.3)',
            transition: 'all 0.3s ease',
            textTransform: 'uppercase',
            letterSpacing: '1px'
          }}
          onMouseEnter={(e) => {
            e.target.style.transform = 'translateY(-2px)';
            e.target.style.boxShadow = '0 6px 20px rgba(76, 175, 80, 0.4)';
          }}
          onMouseLeave={(e) => {
            e.target.style.transform = 'translateY(0)';
            e.target.style.boxShadow = '0 4px 15px rgba(76, 175, 80, 0.3)';
          }}
          >
            🚀 Get Started
          </button>
        </Link>
        <div style={{
          fontSize: '0.9em',
          color: '#aaa',
          marginTop: '12px',
          fontStyle: 'italic'
        }}>
          Sign in to start saving on DoorDash orders
        </div>
      </div>
      
      <style>{`
        @keyframes pulse {
          0% { transform: scale(1); }
          50% { transform: scale(1.05); }
          100% { transform: scale(1); }
        }
      `}</style>
    </div>
  );
} 